module.exports = __webpack_public_path__ + "static/media/293957.883eaa09.png";